// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../endOfDay/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var endOfDay = convertToFP(fn, 1);
export default endOfDay;